/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import MuiInputLabel, { type InputLabelProps } from '@mui/material/InputLabel';
import React from 'react';

/**
 * Label for `Input`s. Should be used in conjunction with `Input` and
 * `FormControl`.
 *
 * Consider using the `TextField` component for a more complete input solution.
 */
export const InputLabel = ({
  children,
  disabled,
  error,
  htmlFor,
  required,
}: Pick<InputLabelProps, 'children' | 'disabled' | 'error' | 'htmlFor' | 'required'>) => (
  <MuiInputLabel
    css={css`
      position: static;
    `}
    data-testid="nds-component-inputlabel"
    disabled={disabled}
    error={error}
    htmlFor={htmlFor}
    required={required}
  >
    {children}
  </MuiInputLabel>
);
